import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { BrowserModule } from '@angular/platform-browser';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgDragDropModule } from 'ng-drag-drop';
import { NgProgressModule } from 'ngx-progressbar';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { SharedModule } from '../shared/shared.module';

import { CatalogueListV2Component } from './catalogue-list-v2/catalogue-list-v2.component';
import { CatalogueEditV2Component } from './catalogue-edit-v2/catalogue-edit-v2.component';
import { NewsletterDetailV2Component } from './newsletter-detail-v2/newsletter-detail-v2.component';
import { NewsletterEditV2Component } from './newsletter-edit-v2/newsletter-edit-v2.component';
import { NewsletterSectionV2Component } from './newsletter-edit-v2/newsletter-section-v2/newsletter-section-v2.component';
import { NewsletterPromoV2Component } from './newsletter-edit-v2/newsletter-promo-v2/newsletter-promo-v2.component';
import { CanActivateCateloguesV2 } from './catalogues-v2.guard';
import { CatalogueSubscriptionsV2Component } from './catalogue-subscriptions-v2/catalogue-subscriptions-v2.component';

import { NewsletterSectionBlockV2Component } from './newsletter-edit-v2/newsletter-section-v2/newsletter-section-block-v2/newsletter-section-block-v2.component';
import { CataloguesV2RoutingModule } from './catalogues-v2-routing.module';
import { RouteTransformerDirectiveV2 } from './routeTransformerDirective-v2';
import { AppMotationObserverDirectiveV2 } from './newsletter-detail-v2/app-motation-observer.directive';

import { DragDropModule } from '@angular/cdk/drag-drop'
import { MatExpansionModule } from '@angular/material/expansion';

import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    SharedModule,
    MatSelectModule,
    MatInputModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgProgressModule,
    MatSortModule,
    NgDragDropModule.forRoot(),
    DragDropModule,
    MatCheckboxModule,
    ChildHeaderModule,
    BreadcrumbModule,
    NgbPopoverModule,
    NgSelectModule,
    CataloguesV2RoutingModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule
  ],
  declarations: [
    CatalogueListV2Component,
    CatalogueEditV2Component,
    NewsletterDetailV2Component,
    NewsletterEditV2Component,
    NewsletterSectionV2Component,
    NewsletterPromoV2Component,
    CatalogueSubscriptionsV2Component,
    RouteTransformerDirectiveV2,
    NewsletterSectionBlockV2Component,
    AppMotationObserverDirectiveV2,
  ],
  providers:[
    CanActivateCateloguesV2
  ]
})
export class CataloguesV2Module { }
